import { Component, Input, OnInit } from '@angular/core';

import { SessionService } from '../services/session.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

interface LanguageItem {
  name: string;
  isoCode: string;
}
@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnInit {
  nextIso: string;
  nextLanguageString: string;
  currentLanguage = new BehaviorSubject<LanguageItem>(null);
  languages: LanguageItem[] = [
    {
      name: 'Deutsch',
      isoCode: 'de'
    },
    {
      name: 'English',
      isoCode: 'en'
    }
  ];

  @Input() technicalError = false;

  currentPage: undefined | 'image' | 'abort' | 'success' | 'error' | 'adress' | 'technicalError' = undefined;

  constructor(
    public sessionService: SessionService,
    public translateService: TranslateService,
  ) {
    this.nextIso = this.translateService.currentLang == 'en' ? 'de' : 'en';
    this.nextLanguageString = this.translateService.currentLang == 'en' ? 'Deutsch' : 'English';

    
  }

  
  ngOnInit(): void {
    this.currentPage = this.technicalError ? 'technicalError' : 'image';
  }

  cancel(): void {
    this.sessionService.cancelSession();
  }

  goToAdress(): void {
    this.currentPage = 'adress';
  }

  goToSuccess(): void {
    this.currentPage = 'success';
  }

  goToAbort(): void {
    this.currentPage = 'abort';
  }

  goToError(): void {
    this.currentPage = 'error';
  }

  async submit(): Promise<void> {
    if (await this.sessionService.completeSession()) {
      this.goToSuccess();
    }
    else {
      this.goToError();
    }
  }

  switchLanguage(isoCode: string): void {
    this.nextLanguageString = this.nextLanguageString === 'English' ? 'Deutsch' : 'English';
    this.nextIso = this.nextIso === 'en' ? 'de' : 'en';

    if (!this.translateService?.store?.langs?.includes(isoCode)) { return; }
    this.translateService.use(isoCode);

    const selectedLanguage = this.languages.find(l => l.isoCode === isoCode);
    if (!selectedLanguage) { return; }
    this.currentLanguage.next(selectedLanguage);
  }

}
